import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

const CommentModal = ({ show, handleClose, selectedItem }) => {
    return (
        <Modal show={show} size="md" centered onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Comments</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {selectedItem && (
                    <>
                        <div className="modal-content">
                            <div className="modal-body">
                                <p>
                                    <strong>Member Comment:</strong><br />
                                    {selectedItem.member_comment || <em>No comment from member.</em>}
                                </p>
                            </div>
                        </div>
                    </>
                )}
            </Modal.Body>
        </Modal>
    );
};

export default CommentModal;
